import {Injectable, OnInit} from '@angular/core';
import {AngularFireDatabase} from "angularfire2/database";
import {ScheduleService} from "../schedule-service";
import {Observable} from "rxjs";
import {DataReference} from "../../shared/DataReference";
import {Announcement} from "./Announcement";
import {publish} from "rxjs/operators";
import {refCount} from "rxjs/operators";

/*
  Generated class for the AnnouncementsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnnouncementsProvider implements OnInit {

  announcements$: Observable<Announcement[]>;

  constructor(private af: AngularFireDatabase,
              private scheduleService: ScheduleService) {

    this.announcements$ = this.scheduleService.selectedEvent$
      .filter(x => !!x)
      .switchMap(event =>
        this.af.list(DataReference.getAnnouncementsForEvent(event.id),
            ref => ref.orderByChild(DataReference.ANNOUNCEMENT_STATUS).startAt(Announcement.STATUS_PUBLISHED))
          .snapshotChanges()
          .map(Announcement.fromAngularFireSnapshots)
      ).pipe(
        publish(),
        refCount()
      );
  }

  ngOnInit(): void {

  }

  getAnnouncementForEventById(eventId: string, announcementId: string) : Observable<Announcement> {
    return this.af.object(`${DataReference.getAnnouncementsForEvent(eventId)}/${announcementId}`)
      .valueChanges()
      .map(item => Announcement.fromSnapshot(announcementId, item));
  }


}



// WEBPACK FOOTER //
// ./src/providers/announcements/announcements.ts